<template>
    <div class="kinship-wrapper">
        <div v-if="isShowTitle" class="mb20 fb">{{title}}</div>
        <avue-crud :data="data" v-if="orderId" :option="option" v-model="form" :table-loading="loading" ref="crud" @row-del="rowDel" @row-update="rowUpdate" @row-save="rowSave" @on-load="onLoad" @error="error"></avue-crud>
        <avue-crud :data="data" v-if="!orderId" :option="option" v-model="form" :table-loading="loading" :page.sync="page" ref="crud" @row-del="rowDel" @row-update="rowUpdate" @row-save="rowSave" @on-load="onLoad" @error="error"></avue-crud>
        <div class="tac mt15" slot>
            <el-button type="primary" size="mini" icon="el-icon-plus" v-if="isShowBtn" @click="$refs.crud.rowAdd()">{{addBtnTitle}}</el-button>
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { remove, update, add } from "@/api/order/kinship";
import { mapGetters } from "vuex";
import { cardid, isvalidatemobile } from '@/util/validate'
export default {
    props: {
        isShowTitle: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: '亲属关系'
        },
        isShowBtn: {
            type: Boolean,
            default: true
        },
        addBtnTitle: {
            type: String,
            default: '添加'
        },
        orderId: {
            type: String,
            default: ''
        },
        list: {
            type: Array
        },
        type: {
            type: 'String',
            default: ''
        },
        isOpt: {
            type: Boolean,
            default: true
        }
    },
    data() {
        var checkCardid = (rule, value, callback) => {
            let list = cardid(value);
            if (list[0] && list[1] !== "证件号码不能为空") {
                return callback(new Error(list[1]));
            } else {
                callback();
            }
        };
        var checkPhone = (rule, value, callback) => {
            let list = isvalidatemobile(value);
            if (list[0]) {
                return callback(new Error(list[1]));
            } else {
                callback();
            }
        };

        return {
            form: {},
            loading: true,
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            data: [],
            option: {
                size: 'mini',
                border: true,
                align: 'center',
                menuAlign: 'center',
                delBtn: true,
                viewBtn: true,
                addBtn: false,
                cellBtn: false,
                columnBtn: false,
                refreshBtn: false,
                menuBtn: false,
                labelWidth: 100,
                menu: this.isOpt,
                column: [{
                        label: '姓名',
                        prop: 'name',
                        row: true,
                        span: 24,
                        rules: [{
                            required: true,
                            message: "请输入姓名",
                            trigger: "blur"
                        }]
                    },
                    {
                        label: '身份证编号',
                        prop: 'cardId',
                        row: true,
                        span: 24,
                        rules: [{
                            // required: true,
                            trigger: "blur",
                            validator: checkCardid
                        }]
                    },
                    {
                        label: '年龄',
                        prop: 'age',
                        row: true,
                        span: 24,
                        rules: [{
                            // required: true,
                            trigger: "blur"
                        }],
                          formatter: (row, value, label, column) => {
                            return row.age == -1? '-': row.age
                        },
                    },
                    {
                        label: '文化程度',
                        prop: 'standard',
                        row: true,
                        span: 24,
                        type: 'select',
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'education_degree'
                        },
                        formatter: (row, value, label, column) => {
                            return label
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        rules: [{
                            // required: true,
                            trigger: "blur"
                        }]
                    },
                    {
                        label: '收入',
                        prop: 'income',
                        row: true,
                        span: 24,
                        rules: [{
                            // required: true,
                            trigger: "blur"
                        }]
                    },
                    {
                        label: '职业',
                        prop: 'occupation',
                        row: true,
                        span: 24,
                        rules: [{
                            // required: true,
                            trigger: "blur"
                        }]
                    },
                    {
                        label: '关系',
                        prop: 'relation',
                        row: true,
                        span: 24,
                        type: 'select',
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'relationship'
                        },
                        formatter: (row, value, label, column) => {
                            return label
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        rules: [{
                            required: true,
                            message: "请输入关系",
                            trigger: "blur"
                        }]
                    },
                    {
                        label: '联系方式',
                        prop: 'phone',
                        row: true,
                        span: 24,
                        rules: [{
                            required: true,
                            trigger: "blur",
                            validator: checkPhone
                        }]
                    },
                    {
                        label: '说明',
                        prop: 'instructions',
                        row: true,
                        span: 24,
                        
                    },
                    {
                        label: '订单id',
                        prop: 'orderId',
                        display: false,
                        hide: true,
                        span: 24,
                        disabled: true
                    }
                ]
            }
        }
    },
    watch: {
        orderId() {
            this.form.orderId = this.orderId
        },
        list: {
            deep: true,
            handler(val) {
                this.data = this.list
            }
        },
    },
    methods: {
        rowSave(row, done, loading) {
            if (!this.orderId) {
                this.data.push(row)
                done();
                this.$emit('getList', this.data)
                return
            }
            row.orderId = this.orderId
            add(row).then(res => {
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                this.data.push(res.data.data)
                this.$emit('getList', this.data)
                done();
            }, error => {
                window.console.log(error);
                loading();
            });
        },
        rowUpdate(row, index, done, loading) {
            if (!this.orderId) {
                this.$set(this.data, index, row)
                // [index] = row
                done();
                this.$emit('getList', this.data)
                return
            }
            row.orderId = this.orderId
            update(row).then(res => {
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                this.$set(this.data, index, res.data.data)
                this.$emit('getList', this.data)
                done();
            }, error => {
                window.console.log(error);
                loading();
            });
        },
        rowDel(row, index) {
            if (!this.orderId) {
                this.data.splice(index, 1)
                this.$emit('getList', this.data)
                return
            }
            this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                .then(() => {
                    return remove(row.id);
                })
                .then(() => {
                    this.data.splice(index, 1)
                    this.$emit('getList', this.data)
                    this.$message({
                        type: "success",
                        message: "操作成功!"
                    });
                });
        },
        onLoad(page, params = {}) {
            this.loading = true;
            if ((this.list && this.list.length > 0) || !this.form.orderId) {
                this.data = this.list || []
                this.page.total = this.data.length;
                this.loading = false;
                return
            }
        },
        error(err) {
            this.$message.success('请填写完整信息');
        }
    }
}

</script>
<style>
.kinship-wrapper .avue-crud__menu {
    display: none !important;
}

</style>
